import {
  LuCheck,
  LuClock3,
  LuReceipt,
  LuRefreshCcw,
  LuUserRound,
  LuX,
} from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import styles from "./EstadoCompra.module.scss";

const STATUS = Object.freeze({
  SUCCESS: "success",
  PENDING: "pending",
  REJECTED: "rejected",
});

const CONFIG = {
  [STATUS.SUCCESS]: {
    icon: LuCheck,
    iconClass: "success",
    defaultTitle: "Gracias por tu compra",
    defaultDesc:
      "Tu compra ha sido realizada con éxito. Te enviamos un correo con los detalles de tu pedido.",
    showConfetti: true,
    secondaryIcon: LuReceipt,
    secondaryLabel: "Ver mi compra",
  },
  [STATUS.PENDING]: {
    icon: LuClock3,
    iconClass: "pending",
    defaultTitle: "Pago pendiente",
    defaultDesc:
      "Estamos procesando tu pago. Cuando se confirme, te enviaremos un correo con los detalles de tu pedido.",
    showConfetti: true,
    secondaryIcon: LuReceipt,
    secondaryLabel: "Ver mi compra",
  },
  [STATUS.REJECTED]: {
    icon: LuX,
    iconClass: "rejected",
    defaultTitle: "Pago rechazado",
    defaultDesc:
      "No pudimos confirmar el pago. Podés intentar nuevamente o revisar los datos del método de pago.",
    showConfetti: false,
    secondaryIcon: LuRefreshCcw,
    secondaryLabel: "Reintentar pago",
  },
};

export default function EstadoCompra({
  status = STATUS.SUCCESS,
  title,
  description,
  showConfetti,

  // Navegación dinámica por props (puede ser string o number)
  // - string: navigate("/ruta")
  // - number: navigate(-1)
  toPrimary = "/usuario",
  toSecondary = "/usuario?tab=ordenes",

  onPrimaryClick,
  onSecondaryClick,

  primaryLabel = "Ir a mi perfil",
  secondaryLabel,
  showSecondary = true,
}) {
  const navigate = useNavigate();

  const cfg = CONFIG[status] ?? CONFIG[STATUS.SUCCESS];
  const Icon = cfg.icon;
  const SecondaryIcon = cfg.secondaryIcon;

  const resolvedTitle = title ?? cfg.defaultTitle;
  const resolvedDesc = description ?? cfg.defaultDesc;

  const resolvedConfetti =
    typeof showConfetti === "boolean" ? showConfetti : cfg.showConfetti;

  const resolvedSecondaryLabel = secondaryLabel ?? cfg.secondaryLabel;

  const go = (to) => {
    if (typeof to === "number") return navigate(to);
    if (typeof to === "string" && to.trim()) return navigate(to);
  };

  const handlePrimary = () => {
    if (typeof onPrimaryClick === "function") return onPrimaryClick();
    return go(toPrimary);
  };

  const handleSecondary = () => {
    if (typeof onSecondaryClick === "function") return onSecondaryClick();
    return go(toSecondary);
  };

  return (
    <section className={styles.containerPagoExitoso}>
      <div className={styles.successCard}>
        {resolvedConfetti && (
          <div
            className={styles.confetti}
            aria-hidden="true"
          >
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
        )}

        <div
          className={`${styles.statusIcon} ${
            status === "success"
              ? styles.successIcon
              : status === "pending"
              ? styles.pendingIcon
              : styles.rejectedIcon
          }`}
        >
          <Icon size={26} />
        </div>
        <h4 className={styles.title}>{resolvedTitle}</h4>
        <p className={styles.description}>{resolvedDesc}</p>

        <div className={styles.actions}>
          <PrimaryButton
            className={styles.profileBtn}
            onClick={handlePrimary}
            type="button"
          >
            <span className={styles.btnContent}>
              <LuUserRound size={18} />
              {primaryLabel}
            </span>
          </PrimaryButton>

          {showSecondary && (
            <button
              className={styles.secondaryBtn}
              type="button"
              onClick={handleSecondary}
            >
              <span className={styles.btnContent}>
                <SecondaryIcon size={18} />
                {resolvedSecondaryLabel}
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export { STATUS as PAGO_STATUS };

// <PasoEstadoPago
//   status={PAGO_STATUS.SUCCESS}
//   toPrimary="/usuario"
//   toSecondary="/mis-compras"
// />

// <PasoEstadoPago
//   status={PAGO_STATUS.PENDING}
//   toPrimary="/usuario"
//   toSecondary={-1}
// />

// <PasoEstadoPago
//   status={PAGO_STATUS.REJECTED}
//   onSecondaryClick={() => reintentarPago()}
// />
